module.exports = __webpack_public_path__ + "img/logo_gowe.86931a69.png";